/**
 * Page title row for the Leads hub (currently the “Leads” heading only).
 *
 * Where: `Leads` page above filters/table.
 * Uses: MUI typography only.
 * Behavior: static title today; safe to extend with actions later.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';

interface LeadsHeaderProps {}

export const LeadsHeader: React.FC<LeadsHeaderProps> = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>Leads</Typography>
    </Box>
  );
};

